<div class="ics-picture-view-component">
  <ng-template #icsPicAreaTemplate>
    <div class="picture-area">
      <ion-header slot="fixed">
        <ion-toolbar *ngIf="config.selectable">
          <ion-button fill="clear" size="small" slot="start" (click)="selectAllPictures()">全選択</ion-button>
          <ion-button fill="clear" size="small" slot="start" *ngIf="getSelectMode()" (click)="deSelectAllPictures()">全解除</ion-button>
          <ion-button fill="clear" size="small" slot="end" *ngIf="!getSelectMode()" (click)="setSelectMode(true)">選択</ion-button>
          <ion-button fill="clear" size="small" slot="end" *ngIf="getSelectMode() && config.cutAndPaste && pasteButton" (click)="pastePictures()"><ion-icon name="paste-outline"></ion-icon></ion-button>
          <ion-button
            fill="clear"
            size="small"
            slot="end"
            *ngIf="getSelectMode() && config.download"
            aria-label="選択した写真をダウンロード"
            title="ダウンロード"
            [disabled]="downloadInProgress || !hasSelectedPictures()"
            (click)="downloadPictures()">
            <ion-spinner name="crescent" *ngIf="downloadInProgress"></ion-spinner>
            <ion-icon name="download-outline" *ngIf="!downloadInProgress"></ion-icon>
          </ion-button>
          <ion-button fill="clear" size="small" slot="end" *ngIf="getSelectMode() && config.cutAndPaste" (click)="cutPictures()"><ion-icon name="cut-outline"></ion-icon></ion-button>
          <ion-button fill="clear" size="small" slot="end" *ngIf="getSelectMode() && config.delete" (click)="deletePictures()"><ion-icon name="trash-outline"></ion-icon></ion-button>
          <ion-button fill="clear" size="small" slot="end" *ngIf="getSelectMode()" (click)="cancelSelectMode()"><ion-icon name="close-outline"></ion-icon></ion-button>
        </ion-toolbar>
      </ion-header>
      <ion-content class="picture-contents-area">
        <ion-refresher slot="fixed" *ngIf="config.refresh" (ionRefresh)="refreshData($event)">
          <ion-refresher-content></ion-refresher-content>
        </ion-refresher>
        <div class="picture-thumnail-area">
          <div class="picture-thumnail-list" [ngStyle]="getGridStyle()">
            <div class="picture-thumbnail" *ngFor="let picture of pictures" (click)="clickPicture(picture)">
              <div class="selected-pic" *ngIf="picture.mark">
                <ion-icon name="checkmark-circle" class="checkmark-icon"></ion-icon>
              </div>
              <img [src]="picture.pic.image" alt="picture.pic.filename">
              <span class="annotation-status-badge" *ngIf="picture.pic.hasAnnotation" aria-label="注釈済み">
                <ion-icon name="pencil-outline" aria-hidden="true"></ion-icon>
              </span>
            </div>
            <ion-infinite-scroll #infiniteScroll threshold="100px" (ionInfinite)="loadMoreData($event)" *ngIf="config.infiniteScroll">
              <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more data...">
              </ion-infinite-scroll-content>
            </ion-infinite-scroll>
          </div>
        </div>
      </ion-content>
    </div>
  </ng-template>
  <ng-container *ngTemplateOutlet="icsPicAreaTemplate"></ng-container>
</div>
